import { useState, useEffect } from "react";

import './LineFixed.css';

export default function LineFixed(){
    return(
        <>
            <div className="line_1" />
            <div className="line_2" />
            <div className="line_3" />
        </>
    )
}